import styled from "styled-components";
import { Avatar } from "@mui/material";
import Button from "@mui/material/Button";

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1080px;
  margin: auto;
  margin-top: ${(props) => (props.tabbedLayout ? "120px" : 0)};
`;

const StyledAvatar = styled(Avatar)`
  font-size: 12px;
  margin-right: 10px;
  background: ${(props) => props.bgcolor};
`;

const StyledAvatarContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledButton = styled(Button)`
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 3px;
  border: 1px solid #35908d;
  font-weight: 600;

  &.default {
    margin-left: 10px;
    border: 1px solid #e0e0e0;
  }
`;

const StyledActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledDatePickerContainer = styled.div`
  background: white;
  width: 250px;
  border: 1px solid #d3d3d3;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  position: absolute;
  z-index: 999999;
  padding: 10px;
  display: none;

  ${(props) =>
    props.open === true &&
    `
    display: block;
    `}
`;

export {
  StyledAvatar,
  StyledActionButtons,
  StyledAvatarContainer,
  StyledButton,
  BodyContainer,
  StyledDatePickerContainer
};
